import { inject, injectable } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import FileDownloadLinkGenerator
  from '@/creditflowresearch/application/DI/FileDownloadLinkGenerator/FileDownloadLinkGenerator';
import type { ICorporateBondScreenerExportPayload } from '@/creditflowresearch/domain/vo/Bondscreener/ICorporateBondScreenerExportPayload';
import type { IAbsBondScreenerExportPayload } from '@/creditflowresearch/domain/vo/Bondscreener/IAbsBondScreenerExportPayload';

@injectable()
class DownloadRepository {
  constructor(
    @inject(FileDownloadLinkGenerator) private readonly fileDownloadLinkGenerator: FileDownloadLinkGenerator,
  ) {}

  getExcelExportUrlBondAnalyticsContacts = async (): Promise<string> => {
    const entityId = this.fileDownloadLinkGenerator.generateUniqueId();
    const request = new Request('finsight_web.bond.investor.analytics.get_bi_investor_login_stats_export', { exportId: entityId });
    return this.fileDownloadLinkGenerator.getFileLink(request, entityId);
  };

  getExcelExportUrlTraceAnalyticsContacts = async (): Promise<string> => {
    const entityId = this.fileDownloadLinkGenerator.generateUniqueId();
    const request = new Request('finsight_web.bond.investor.analytics.get_trace_investor_login_stats_export', { exportId: entityId });
    return this.fileDownloadLinkGenerator.getFileLink(request, entityId);
  };

  exportDealToExcel = async (dealId: string): Promise<string> => {
    const entityId = this.fileDownloadLinkGenerator.generateUniqueId();
    const request = new Request('finsight_web.deal_transaction.deal.generate_deal_card_export', { dealId, exportId: entityId });
    return this.fileDownloadLinkGenerator.getFileLink(request, entityId);
  };

  getBondExcelExportUrl = async (
    assetClassId: string,
    filtersPayload: any,
    search: string,
    url: string,
  ): Promise<string> => {
    const entityId = this.fileDownloadLinkGenerator.generateUniqueId();
    const request = new Request('finsight_web.market.bond.generate_bond_document_export', {
      filter: { ...filtersPayload, includedAssetClassId: assetClassId }, exportId: entityId, search, url,
    });
    return this.fileDownloadLinkGenerator.getFileLink(request, entityId);
  };

  getTopCompanyExcelExport = async (payload: any = {}): Promise<string> => {
    const entityId = this.fileDownloadLinkGenerator.generateUniqueId();
    const request = new Request('finsight_web.market.company.generate_top_parents_document_export', { ...payload, exportId: entityId });
    return this.fileDownloadLinkGenerator.getFileLink(request, entityId);
  };

  exportCorporateBondScreenerExcel = async (
    payload: ICorporateBondScreenerExportPayload,
    callback: (progress: number, timeLeft: number) => void,
  ): Promise<string> => {
    const request = new Request('cfr.bondscreener.corp.generate_export', payload);
    return this.fileDownloadLinkGenerator.getFileLink(request, payload.exportId, callback);
  };

  exportAbsBondScreenerExcel = async (
    payload: IAbsBondScreenerExportPayload,
    callback: (progress: number, timeLeft: number) => void,
  ): Promise<string> => {
    const request = new Request('cfr.bondscreener.abs.generate_export', payload);
    return this.fileDownloadLinkGenerator.getFileLink(request, payload.exportId, callback);
  };
}

export default DownloadRepository;
